import React, { useState } from 'react';
import ContactModal from '../ContactModal/ContactModal';
import './Header.scss';

const Header = () => {
	const [showContactModal, setShowContactModal] = useState(false);

	return (
		<>
			<header className="header">
				<div className="header__background"></div>

				<div className="header__content">
					<div className="header__container">
						<h1 className="header__title">Jeremy Boutin</h1>
						<p className="header__subtitle">Senior Software Engineer</p>

						<div className="header__location">
							<svg className="header__location-icon" fill="currentColor" viewBox="0 0 20 20">
								<path
									fillRule="evenodd"
									d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
									clipRule="evenodd"
								/>
							</svg>
							<span>Massachusetts, USA</span>
						</div>

						<div className="header__actions">
							<a
								href="/JBoutin-Resume.pdf"
								target="_blank"
								className="header__button header__button--primary"
							>
								Download Resume
							</a>
							<a
								href="https://linkedin.com/in/jboutin"
								target="_blank"
								rel="noopener noreferrer"
								className="header__button header__button--secondary"
							>
								<img src="https://jbout.in/images/li.png" alt="LinkedIn Profile" />
							</a>
							<a
								href="https://github.com/jboutin"
								target="_blank"
								rel="noopener noreferrer"
								className="header__button header__button--secondary"
							>
								<img src="https://jbout.in/images/gh.png" alt="GitHub Profile" />
							</a>
						</div>
					</div>
				</div>
			</header>

			<ContactModal isOpen={showContactModal} onClose={() => setShowContactModal(false)} />
		</>
	);
};

export default Header;
